import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { isFiniteNumber } from '@/common/utils/number';
import { useVisibleCapexPercentage } from '../context/VisibleItemFinancialsContext';
import type { ItemsTableRow } from '../types';

export const CapexPercentageCell = ({ row }: { row: ItemsTableRow }) => {
  const percentage = useVisibleCapexPercentage(row.id);

  return isFiniteNumber(percentage) && <OverflowTooltip>{percentage}%</OverflowTooltip>;
};
